import { useMutation } from '@tanstack/react-query';
import api from 'services/api';

const useDownloadReportMarkdown = () => {
  const download = async ({ experimentId }) => {
    const res = await api.get(`api/v1/trials/experiments/${experimentId}/report/download/editable`);

    let filename = `experiment_report_${experimentId}.md`;
    const header = res.headers.get('Content-Disposition');
    if (header) {
      const parts = header.split(';');
      filename = parts[1]?.split('=')[1]?.replace(/"/g, '') || filename;
    }

    const data = await res.blob();
    return { data, filename };
  };

  return useMutation(download);
};

export default useDownloadReportMarkdown;
